import { useAtomValue } from 'jotai';
import { CuboidStyleHandlers } from '@/modules/cuboids/types';
import { useDefaultCuboidStyles } from '@/modules/cuboids/hooks/useDefaultCuboidStyles';
import { LabellingCuboid } from '@/types';
import { useGetCuboidColor } from './useGetCuboidColor';
import { useCuboidState } from './useCuboidState';

export const useCuboidStyleHandlers = (): CuboidStyleHandlers<LabellingCuboid> => {
  const cuboidState = useCuboidState();
  const isCuboidVisibilityBoxEnabled = useAtomValue(cuboidState.isCuboidVisibilityBoxEnabled);
  const getCuboidColor = useGetCuboidColor();

  return useDefaultCuboidStyles(getCuboidColor, isCuboidVisibilityBoxEnabled);
};
